module.exports = __webpack_public_path__ + "img/1.4b08fcc8.png";